import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'app-coverage-note',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './coverage-note.component.html',
})
export class CoverageNoteComponent {}
